<script>
    import 'whatwg-fetch'
    import {onMount} from 'svelte';
    import Login from "./Login.svelte";
    import Cookies from '../public/vendor/js-cookie/js.cookie'

    import fetchIntercept from 'fetch-intercept';
    import Common from "../public/lib/common";
    import OverallCharts from "./OverallCharts.svelte";
    import Clients from "./Clients.svelte";
    import Rents from "./Rents.svelte";
    import Etoll from "./Etoll.svelte";
    import Costs from "./Costs.svelte";
    import ClientModal from "./modals/ClientModal.svelte";
    import Calendar from "./Calendar.svelte";
    import Cars from "./Cars.svelte";

    let logged = false;

    let data = {};

    let mode = 'clients';

    let clients;
    let rents;
    let overallCharts;
    let costs;
    let cars;
    let calendar;
    let etoll;

    /**
     * Fetch interceptor
     */
    fetchIntercept.register({
        request: function (url, config) {
            const withDefaults = Object.assign({}, config);
            withDefaults.headers = withDefaults.headers || new Headers({
                'UUID': Cookies.get('uuid')
            });
            return [url, withDefaults];
        },

        requestError: function (error) {
            return Promise.reject(error);
        },

        response: function (response) {
            return response;
        },

        responseError: function (error) {
            return Promise.reject(error);
        }
    });

    const paymentsNumberData = {
        labelsData: [],
        valuesData: [],
        titleData: 'Ilość płatności'
    };

    const paymentsValueData = {
        labelsData: [],
        valuesData: [],
        titleData: 'Wartość płatności'
    };

    var extractInternalChartData = function (data) {
        for (const key in data) {
            return data[key];
        }
    };

    var originalDoughnutDraw = Chart.controllers.doughnut.prototype.draw;
    Chart.helpers.extend(Chart.controllers.doughnut.prototype, {
        draw: function () {
            originalDoughnutDraw.apply(this, arguments);

            var chart = this.chart.chart;
            var ctx = chart.ctx;

            ctx.imageSmoothingEnabled = true;
            var width = chart.width;
            var height = chart.height;

            var fontSize = (height / 200).toFixed(2);
            ctx.font = fontSize + "em Verdana";
            ctx.textBaseline = "middle";

            let sum = 0;
            for (var i = 0; i < chart.config.data.datasets[0].data.length; i++) {
                sum += chart.config.data.datasets[0].data[i];
                if (chart.config.data &&
                    chart.config.data.datasets[0]._meta) {
                    var internalData = extractInternalChartData(chart.config.data.datasets[0]._meta);
                    if (internalData && internalData.data && internalData.data[i] && internalData.data[i].hidden) {
                        sum -= chart.config.data.datasets[0].data[i];
                    }
                }
            }

            var text = sum,
                textX = Math.round((width - ctx.measureText(text).width) / 2),
                textY = height / 2 + 40;

            ctx.fillText(text, textX, textY);
        }
    });

    onMount(async () => {
        let x = Cookies.get('uuid');
        if (x) {
            setLoggedIn(x, Cookies.get('name'));
            setupMode('clients');
        }
    });

    function reloadData(callback) {
        Common.getStats().then(function (response) {
            data = response;
            data.cars.forEach(a => {
                if (a.nameSuffix) {
                    a.name = a.name + " " + a.nameSuffix;
                }
            })
            if (callback) {
                callback();
            }
        }).catch(function (present) {
            console.log(present);
            Cookies.set('uuid', null);
            Cookies.set('name', name);
            logged = false;
        });
    }

    function setLoggedIn(uuid, name) {
        logged = true;
        Cookies.set('uuid', uuid, {domain: '.busbrat.pl'});
        Cookies.set('name', name, {domain: '.busbrat.pl'});
        data = {};
        reloadData()
    }

    function loggedIn(event) {
        setLoggedIn(event.detail.uuid, event.detail.name);
    }

    function setupMode(newMode) {
        mode = newMode;
        reloadData(() => {
            setTimeout(function () {
                switch (mode) {
                    case "charts":
                        overallCharts.setup(data);
                        break;
                    case "costs":
                        costs.setup(data);
                        break;
                    case "clients":
                        clients.setup(data);
                        break;
                    case "rents":
                        rents.setup(data);
                        break;
                    case "calendar":
                        calendar.setup(data);
                        break;
                    case "cars":
                        cars.setup(data);
                        break;
                }
            }, 100);
        });
    }
</script>

<main style="min-height: 100%" class="flex justify-center">
    {#if logged}
        <div class="container-fluid " class:hidden={!logged}>
            <div class="row">
                <div class="col-12 mt-4">
                    <div class="text-center flex flex-col chart-container minHT50 menuButtonsContainer">
                        <button type="button"
                                class="menuButton btn {mode === 'clients' ? 'btn-light' : 'btn-secondary'} maxWt200"
                                on:click="{() => setupMode('clients')}">
                            <span><i class="fas fa-address-book"></i> <span
                                    class="d-none d-sm-inline">Klienci</span></span>
                        </button>
                        <button type="button"
                                class="menuButton btn {mode === 'rents' ? 'btn-light' : 'btn-secondary'} maxWt200"
                                on:click="{() => setupMode('rents')}">
                            <span><i class="fas fa-truck"></i> <span class="d-none d-sm-inline">Wynajmy</span></span>
                        </button>
                        <button type="button"
                                class="menuButton btn {mode === 'costs' ? 'btn-light' : 'btn-secondary'} maxWt200"
                                on:click="{() => setupMode('costs')}">
                            <span><i class="fas fa-dollar-sign"></i> <span
                                    class="d-none d-sm-inline">Koszty</span></span>
                        </button>
                        <button type="button"
                                class="menuButton btn {mode === 'charts' ? 'btn-light' : 'btn-secondary'} maxWt200"
                                on:click="{() => setupMode('charts')}">
                            <span><i class="fas fa-chart-area"></i> <span
                                    class="d-none d-sm-inline">Wykresy</span></span>
                        </button>
                        <button type="button"
                                class="menuButton btn {mode === 'calendar' ? 'btn-light' : 'btn-secondary'} maxWt200"
                                on:click="{() => setupMode('calendar')}">
                            <span><i class="fas fa-calendar"></i> <span
                                    class="d-none d-sm-inline">Kalendarz</span></span>
                        </button>
                        <button type="button"
                                class="menuButton btn {mode === 'etoll' ? 'btn-light' : 'btn-secondary'} maxWt200"
                                on:click="{() => setupMode('etoll')}">
                            <span><i class="fas fa-road"></i> <span class="d-none d-sm-inline">eToll</span></span>
                        </button>
                        <button type="button"
                                class="menuButton btn {mode === 'cars' ? 'btn-light' : 'btn-secondary'} maxWt200"
                                on:click="{() => setupMode('cars')}">
                            <span><i class="fas fa-car"></i> <span class="d-none d-sm-inline">Samochody</span></span>
                        </button>
                    </div>
                </div>
            </div>

            {#if (mode === 'rents')}
                <Rents bind:this={rents}></Rents>
            {/if}
            {#if (mode === 'clients')}
                <Clients bind:this={clients}></Clients>
            {/if}
            {#if (mode === 'charts')}
                <OverallCharts bind:this={overallCharts}></OverallCharts>
            {/if}
            {#if (mode === 'costs')}
                <Costs bind:this={costs}></Costs>
            {/if}
            {#if (mode === 'calendar')}
                <Calendar bind:this={calendar}></Calendar>
            {/if}
            {#if (mode === 'etoll')}
                <Etoll bind:this="{etoll}"></Etoll>
            {/if}
            {#if (mode === 'cars')}
                <Cars bind:this="{cars}"></Cars>
            {/if}
        </div>

    {:else}
        <Login on:logged={loggedIn}/>
    {/if}
</main>

<style>
</style>

<ClientModal></ClientModal>

